export const prop = 'clientName';

export const config = (labels) => ({
	id: 'clientNameColumn',
	label: labels.clientName,
	propName: prop,
	width: '25%',
	sortBy: prop
});
